import { useEffect } from 'react';
import { addEventListener } from '../utils/dom';
function useKeyPress() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var onKeyPress = arguments.length > 1 ? arguments[1] : undefined;
  useEffect(function () {
    if (!onKeyPress) {
      return;
    }
    var handleKeyDown = function handleKeyDown(event) {
      var keyCode = event.keyCode;
      if (keys.includes(keyCode)) {
        onKeyPress(event);
      }
    };
    var off = addEventListener('keydown', handleKeyDown);
    return function () {
      return off === null || off === void 0 ? void 0 : off();
    };
  }, [keys, onKeyPress]);
}
export default useKeyPress;